/* wf-compare-tray.js – "Jämför" på elfordonens produktkort + jämförelsefält (snippets/wf-compare-tray.liquid), 2026-10-25.
   Korttyper: kollektion/sök (.wf-pc, ritas av wf-collection-filter.js), startsidans populära (.wf-po__card), elcykel-karusellen
   (.wf-eb__card) och topplistor (.wf-tl__card). Knappen läggs bara på kort vars data-wf-ty (produkttyp, översatt per marknad) känns igen
   som en jämförelsekategori; servern bekräftar kategorin vid klick (/products/<h>?view=wf-compare). Nya kort fångas via MutationObserver.
   Urvalet delas med jämförelsesidan i localStorage "wf_cmp_v1": { cur, sel: { kategori: [{h,t,img}] } }. Max CFG.max, samma kategori. */
(function () {
  'use strict';
  if (window.__wfCmpTray) return; window.__wfCmpTray = 1;
  var el = document.querySelector('[data-wf-cmpt-config]'); if (!el) return;
  var CFG; try { CFG = JSON.parse(el.textContent); } catch (e) { return; }
  if (!CFG.page) return;
  var T = CFG.t || {}, MAX = CFG.max || 4, LS = 'wf_cmp_v1', ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var meta = {};
  function tr(k, m) { var s = T[k] || k; if (m) for (var p in m) s = s.split('[' + p + ']').join(m[p]); return s; }
  function esc(s) { return ('' + (s == null ? '' : s)).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function load() { try { return JSON.parse(localStorage.getItem(LS)) || {}; } catch (e) { return {}; } }
  function store(s) { try { localStorage.setItem(LS, JSON.stringify(s)); } catch (e) {} }
  function catT(k) { for (var i = 0; i < (CFG.cats || []).length; i++) if (CFG.cats[i].k === k) return CFG.cats[i].t; return k; }
  function cur() { var s = load(); return { s: s, k: s.cur || '', items: (s.sel && s.cur && s.sel[s.cur]) || [] }; }
  function handleOf(a) { try { var p = new URL(a.href, location.href).pathname, i = p.indexOf('/products/'); return i < 0 ? '' : decodeURIComponent(p.slice(i + 10).split('/')[0]); } catch (e) { return ''; } }
  function has(h) { return cur().items.some(function (o) { return o.h === h; }); }
  /* produkttyp → kategori. Typen är översatt per marknad (sv/en/fr/es/de/it); mobilitet kontrolleras före sparkcykel ("mobility scooter"). */
  var TYPES = [
    ['permobil', /permobil|mobility|elektromobil|movilidad|mobilit|pmr/i],
    ['elrullstol', /rullstol|wheelchair|fauteuil|silla de ruedas|rollstuhl|carrozzina|sedia a rotelle/i],
    ['el-cross', /el-?cross|dirt|motocross|moto cross|moto de cross|crossbike/i],
    ['enhjuling', /enhjuling|unicycle|monoroue|monociclo|einrad|monoruota/i],
    ['elbil-barn', /elbil|electric car|voiture|coche|elektroauto|auto elettrica/i],
    ['elcykel', /elcykel|trehjuling|e-?bike|bike|v[eé]lo|bicicleta|bicicletta|fahrrad|tricycle|triciclo|dreirad/i],
    ['elmoped', /moped|scooter [eé]lectrique|moto el[eé]ctrica|scooter elettrico/i],
    ['elsparkcykel', /elsparkcykel|scooter|trottinette|patinete|monopattino/i]
  ];
  function catOfType(t) { t = ('' + (t || '')).trim(); if (!t) return ''; for (var i = 0; i < TYPES.length; i++) if (TYPES[i][1].test(t)) return TYPES[i][0]; return ''; }
  function track(name, data) {
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') { var c = cur(), d = { category: c.k, models: c.items.map(function (o) { return o.h; }), count: c.items.length, page_type: (document.body.className.match(/template-(\w+)/) || [])[1] || '' }; for (var k in (data || {})) d[k] = data[k]; Shopify.analytics.publish('wf_compare_' + name, d); } } catch (e) {}
  }
  var KINDS = [
    { card: '.wf-pc', link: 'a.wf-pc__card', media: '.wf-pc__media', name: '.wf-pc__name' },
    { card: '.wf-po__card', link: null, media: '.wf-po__media', name: '.wf-po__name, h3' },
    { card: '.wf-eb__card', link: null, media: '.wf-eb__media', name: '.wf-eb__name, h3' },
    { card: '.wf-tl__card', link: 'a.wf-tl__card-link', media: '.wf-tl__media', name: '.wf-tl__name, h3' }
  ];
  var SEL = KINDS.map(function (k) { return k.card; }).join(',');

  var ICO_CMP = '<svg viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M3 7h12m0 0-3-3m3 3-3 3M17 13H5m0 0 3-3m-3 3 3 3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICO_OK = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M3.5 8.5l2.8 2.8 6.2-6.6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICO_X = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M4 4l8 8M12 4l-8 8" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
  var ICO_AR = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M5 12h13"/><path d="M12 6l6 6-6 6"/></svg>';

  /* ---------- knappar på korten ---------- */
  function decorate(scope) {
    KINDS.forEach(function (K) {
      (scope || document).querySelectorAll(K.card).forEach(function (card) {
        if (card.__wfCmpt) return;
        var ty = card.getAttribute('data-wf-ty'); if (ty == null) return;
        card.__wfCmpt = 1;
        var cat = catOfType(ty); if (!cat) return;
        var a = K.link ? card.querySelector(K.link) : card, media = card.querySelector(K.media);
        if (!a || !media || !a.href) return;
        var h = handleOf(a); if (!h) return;
        var im = media.querySelector('img'), nm = card.querySelector(K.name);
        meta['dom:' + h] = { h: h, cat: cat, t: nm ? nm.textContent.trim() : '', img: im ? (im.currentSrc || im.src || '').replace(/([?&])width=\d+/, '$1width=240') : '' };
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'wf-cmpt'; b.setAttribute('data-cmpt', h);
        media.appendChild(b);
        paint(b); focusWatch(b);
      });
    });
  }
  function paint(b) {
    var on = has(b.getAttribute('data-cmpt')), pdp = b.classList.contains('wf-cmpt--pdp');
    b.setAttribute('aria-pressed', on ? 'true' : 'false');
    b.classList.toggle('is-on', on);
    b.innerHTML = (on ? ICO_OK : ICO_CMP) + '<span>' + esc(on ? tr(pdp ? 'pdpOn' : 'trayOn') : tr(pdp ? 'pdpAdd' : 'trayAdd')) + '</span>';
  }
  /* produktsidans "Lägg till i jämförelse" (snippets/wf-compare-button) – kategori, titel och bild finns som data-attribut */
  function decoratePdp() {
    document.querySelectorAll('.wf-cmpt--pdp[data-cmpt]').forEach(function (b) {
      if (b.__wfCmpt) return; b.__wfCmpt = 1;
      var h = b.getAttribute('data-cmpt');
      meta['dom:' + h] = { h: h, cat: b.getAttribute('data-cat') || '', t: b.getAttribute('data-t') || '', img: b.getAttribute('data-img') || '' };
      paint(b);
    });
  }
  /* mobil (kund 2026-10-25): ingen hovring – knappen är en kompakt ikon och fälls ut till "Jämför" när kortet ligger mitt på skärmen */
  var touch = window.matchMedia && matchMedia('(hover: none)').matches, fio = null;
  function focusWatch(b) {
    if (!touch || !('IntersectionObserver' in window)) return;
    if (!fio) fio = new IntersectionObserver(function (es) { es.forEach(function (e) { var btn = e.target.__wfCmptBtn; if (btn) btn.classList.toggle('is-focus', e.isIntersecting); }); }, { rootMargin: '-38% 0px -38% 0px' });
    var card = b.closest('[data-wf-ty]') || b.parentElement; card.__wfCmptBtn = b; fio.observe(card);
  }
  function paintAll() { document.querySelectorAll('.wf-cmpt').forEach(paint); }

  function info(h) {
    if (meta[h]) return Promise.resolve(meta[h]);
    /* kortets egna uppgifter räcker för fältet; servern bekräftar ändå kategorin i bakgrunden */
    return fetch(ROOT + 'products/' + encodeURIComponent(h) + '?view=wf-compare', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (t) { var a = t.indexOf('{'), m = t.indexOf('<!--wf-specs-->'), d = JSON.parse(m > a ? t.slice(a, m) : t.slice(a)); var m = { h: d.h, cat: d.cat, t: d.t, img: d.img ? d.img.replace(/([?&])width=\d+/, '$1width=240') : '' }; meta[h] = m; meta[d.h] = m; return m; });
  }
  function toggle(b) {
    var h = b.getAttribute('data-cmpt');
    if (has(h)) { remove(h); return; }
    function go(m) {
      if (!m.cat) { toast(tr('trayNo')); paint(b); return; }
      var c2 = cur();
      if (c2.items.length && c2.k && c2.k !== m.cat) { confirmSwitch(m, c2.k); return; }
      if (c2.items.length >= MAX) { toast(tr('max', { max: MAX })); return; }
      add(m);
    }
    var dm = meta['dom:' + h];
    if (dm && b.classList.contains('wf-cmpt--pdp')) { go(dm); return; }
    if (dm) {
      /* direkt från kortet; serverns kategori kontrolleras i bakgrunden och rättar urvalet om typen tolkades fel */
      go(dm);
      info(h).then(function (m) {
        if (m.cat === dm.cat) return;
        var s = load(); if (s.sel && s.sel[dm.cat]) { s.sel[dm.cat] = s.sel[dm.cat].filter(function (o) { return o.h !== h && o.h !== m.h; }); store(s); }
        sync(); if (!m.cat) toast(tr('trayNo'));
      }, function () {});
      return;
    }
    b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true');
    info(h).then(function (m) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); go(m); },
      function () { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); toast(tr('error')); });
  }
  function add(m) {
    var s = load(); s.sel = s.sel || {}; s.cur = m.cat;
    var list = (s.sel[m.cat] || []).filter(function (o) { return o.h !== m.h; });
    if (list.length >= MAX) { toast(tr('max', { max: MAX })); return; }
    list.push({ h: m.h, t: m.t, img: m.img }); s.sel[m.cat] = list; store(s);
    track('add', { product_handle: m.h, source: 'card' });
    /* mobil (kund 2026-10-25): fältet visas utfällt en stund efter tillägget och fälls sedan ihop till rubrik + knapp */
    collapsed = false; sync(); say(tr('aAdded', { name: m.t, n: list.length, max: MAX }));
    clearTimeout(colT); if (matchMedia('(max-width: 749px)').matches) colT = setTimeout(function () { if (!userOpened) { collapsed = true; sync(); } }, 2600);
  }
  function remove(h) {
    var s = load(); if (!s.cur || !s.sel || !s.sel[s.cur]) return;
    var o = s.sel[s.cur].filter(function (x) { return x.h === h; })[0];
    s.sel[s.cur] = s.sel[s.cur].filter(function (x) { return x.h !== h; }); store(s); sync();
    if (o) { say(tr('aRemoved', { name: o.t })); track('remove', { product_handle: h, source: 'tray' }); }
  }
  function clearAll() { var s = load(); if (s.cur && s.sel) s.sel[s.cur] = []; store(s); sync(); }

  /* ---------- fältet ---------- */
  /* mobil: fältet startar ihopfällt (rubrik + knapp) när det redan innehåller modeller; tryck på rubriken fäller ut det */
  var tray, collapsed = !!(window.matchMedia && matchMedia('(max-width: 749px)').matches), liveEl, colT, userOpened = false;
  function build() {
    tray = document.createElement('div');
    tray.className = 'wf-cmptray'; tray.setAttribute('role', 'region'); tray.setAttribute('aria-label', tr('trayTitle'));
    document.body.appendChild(tray);
    liveEl = document.createElement('p'); liveEl.className = 'wf-cmptray__sr'; liveEl.setAttribute('aria-live', 'polite'); document.body.appendChild(liveEl);
    tray.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-tray-rm]'); if (rm) { remove(rm.getAttribute('data-tray-rm')); return; }
      if (e.target.closest('[data-tray-clear]')) { clearAll(); return; }
      if (e.target.closest('[data-tray-col]')) { collapsed = !collapsed; userOpened = !collapsed; sync(); return; }
      var go = e.target.closest('[data-tray-go]'); if (go && go.getAttribute('aria-disabled') === 'true') { e.preventDefault(); toast(tr('trayMin')); }
      var yes = e.target.closest('[data-tray-yes]'); if (yes && pending) { var m = pending; pending = null; var s = load(); s.sel = s.sel || {}; s.sel[m.cat] = []; store(s); add(m); return; }
      if (e.target.closest('[data-tray-no]')) { pending = null; sync(); }
    });
  }
  var pending = null;
  function confirmSwitch(m, k) { pending = m; sync(tr('trayOther', { cat: catT(k) })); }
  function sync(question) {
    paintAll();
    var c = cur(), n = c.items.length;
    if (!tray) build();
    var show = n > 0 || !!question;
    tray.classList.toggle('is-on', show);
    document.documentElement.classList.toggle('wf-cmptray-on', show);
    if (!show) { tray.innerHTML = ''; place(); return; }
    var href = CFG.page + '?c=' + encodeURIComponent(c.k) + '&m=' + c.items.map(function (o) { return encodeURIComponent(o.h); }).join(',') + '&src=tray';
    var slots = '';
    for (var i = 0; i < MAX; i++) {
      var o = c.items[i];
      slots += o
        ? '<li class="wf-cmptray__it"><span class="wf-cmptray__th">' + (o.img ? '<img src="' + esc(o.img) + '" alt="" width="56" height="56">' : '') + '</span><span class="wf-cmptray__nm">' + esc(o.t) + '</span><button type="button" class="wf-cmptray__rm" data-tray-rm="' + esc(o.h) + '" aria-label="' + esc(tr('remove', { name: o.t })) + '">' + ICO_X + '</button></li>'
        : '<li class="wf-cmptray__it wf-cmptray__it--e" aria-hidden="true"><span class="wf-cmptray__th"></span></li>';
    }
    tray.classList.toggle('is-col', collapsed && !question && matchMedia('(max-width: 749px)').matches);
    tray.innerHTML = '<div class="wf-cmptray__in">' +
      (question
        ? '<div class="wf-cmptray__q"><p>' + esc(question) + '</p><span><button type="button" class="wf-cmptray__go" data-tray-yes>' + esc(tr('trayRestart')) + '</button><button type="button" class="wf-cmptray__lnk" data-tray-no>' + esc(tr('trayCancel')) + '</button></span></div>'
        : '<div class="wf-cmptray__hd"><button type="button" class="wf-cmptray__col" data-tray-col aria-expanded="' + !collapsed + '"><span class="wf-cmptray__ic">' + ICO_CMP + '</span><span class="wf-cmptray__tt"><b>' + esc(tr('trayTitle')) + '</b><small>' + esc(catT(c.k)) + ' · ' + n + '/' + MAX + '</small></span></button></div>' +
          '<ul class="wf-cmptray__list" role="list">' + slots + '</ul>' +
          '<div class="wf-cmptray__act"><a class="wf-cmptray__go" href="' + esc(href) + '" data-tray-go' + (n < 2 ? ' aria-disabled="true"' : '') + '>' + esc(tr('trayCta', { n: n })) + ICO_AR + '</a><button type="button" class="wf-cmptray__lnk" data-tray-clear>' + esc(tr('clear')) + '</button></div>') +
      '</div>';
    place();
  }
  /* Shopifys chattknapp (shopify-chat, öppen shadow root) ligger centrerad längst ner – fältet läggs ovanför den i stället för att
     täcka den, och sidan får motsvarande luft i botten så att sista kortraden inte göms. */
  function place() {
    if (!tray) return;
    var off = 0;
    try {
      var sc = document.querySelector('shopify-chat'), a = sc && sc.shadowRoot && sc.shadowRoot.querySelector('.activator');
      if (a) { var r = a.getBoundingClientRect(); if (r.width && r.height && r.top > innerHeight * 0.5) off = Math.max(0, Math.round(innerHeight - r.top + 10)); }
    } catch (e) {}
    tray.style.setProperty('--wf-cmpt-b', off ? off + 'px' : '');
    var on = tray.classList.contains('is-on');
    document.body.style.paddingBottom = on ? (tray.offsetHeight + off + 24) + 'px' : '';
  }
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'wf-cmptray__toast'; toastEl.setAttribute('role', 'status'); document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('is-on'); clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
  }
  function say(msg) { if (!liveEl) return; liveEl.textContent = ''; setTimeout(function () { liveEl.textContent = msg; }, 30); }

  /* ---------- händelser ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.wf-cmpt'); if (!b) return;
    e.preventDefault(); e.stopPropagation(); toggle(b);
  }, true);
  window.addEventListener('storage', function (e) { if (e.key === LS) sync(); });
  window.addEventListener('pageshow', function () { sync(); });
  window.addEventListener('resize', place, { passive: true });
  function start() {
    decorate(document); decoratePdp();
    var mq = 0;
    new MutationObserver(function (ms) {
      if (mq) return;
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { mq = requestAnimationFrame(function () { mq = 0; decorate(document); }); break; }
    }).observe(document.querySelector('main') || document.body, { childList: true, subtree: true });
    sync();
    /* chattknappen laddas sent – placera om några gånger de första sekunderna */
    [800, 2000, 4000, 8000].forEach(function (t) { setTimeout(place, t); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
